import { FC } from "react";
import { addYears } from "date-fns";
import { HintTooltip } from "@brg/ui";
import { CustomDateTimePicker } from "_competition/pages/CreateCompetitionPage/stylesEdit";
import { Date32Icon } from "shared/components/tagAdminProjectsSearchBar/date32";
import {
    FieldWrapper,
    FieldLabelRow,
    FieldLabelLeft,
    FieldLabelText,
    HintIcon,
    RequiredStar,
    DatePickerWrap,
} from "../styles";

interface DatePickerFieldProps {
    label: string;
    required?: boolean;
    tooltipText?: string;
    value: Date | null | undefined;
    onChange: (val: Date) => void;
    locale?: string;
    maxDate?: Date;
}

export const DatePickerField: FC<DatePickerFieldProps> = ({
    label,
    required,
    tooltipText,
    value,
    onChange,
    locale,
    maxDate = addYears(new Date(), 5),
}) => {
    return (
        <FieldWrapper>
            <FieldLabelRow>
                <FieldLabelLeft>
                    <FieldLabelText>{label}{required && <RequiredStar>*</RequiredStar>}</FieldLabelText>
                    {tooltipText && (
                        <HintTooltip noArrow activeOnMobile positionY="top" text={tooltipText} onWhiteBg>
                            <HintIcon>?</HintIcon>
                        </HintTooltip>
                    )}
                </FieldLabelLeft>
            </FieldLabelRow>
            <DatePickerWrap>
                <CustomDateTimePicker
                    value={value}
                    calendarIcon={<Date32Icon />}
                    clearIcon={null}
                    format="dd-MM-yyyy"
                    maxDate={maxDate}
                    locale={locale}
                    onChange={onChange}
                />
            </DatePickerWrap>
        </FieldWrapper>
    );
};
import { FC } from "react";
import { addYears } from "date-fns";
import { HintTooltip } from "@brg/ui";
import { CustomDateTimePicker } from "_competition/pages/CreateCompetitionPage/stylesEdit";
import { Date32Icon } from "shared/components/tagAdminProjectsSearchBar/date32";
import {
    FieldWrapper,
    FieldLabelRow,
    FieldLabelLeft,
    FieldLabelText,
    HintIcon,
    RequiredStar,
    DatePickerWrap,
} from "../styles";

interface DatePickerFieldProps {
    label: string;
    required?: boolean;
    tooltipText?: string;
    value: Date | null | undefined;
    onChange: (val: Date) => void;
    locale?: string;
    maxDate?: Date;
}

export const DatePickerField: FC<DatePickerFieldProps> = ({
    label,
    required,
    tooltipText,
    value,
    onChange,
    locale,
    maxDate = addYears(new Date(), 5),
}) => {
    return (
        <FieldWrapper>
            <FieldLabelRow>
                <FieldLabelLeft>
                    <FieldLabelText>{label}{required && <RequiredStar>*</RequiredStar>}</FieldLabelText>
                    {tooltipText && (
                        <HintTooltip noArrow activeOnMobile positionY="top" text={tooltipText} onWhiteBg>
                            <HintIcon>?</HintIcon>
                        </HintTooltip>
                    )}
                </FieldLabelLeft>
            </FieldLabelRow>
            <DatePickerWrap>
                <CustomDateTimePicker
                    value={value}
                    calendarIcon={<Date32Icon />}
                    clearIcon={null}
                    format="dd-MM-yyyy"
                    maxDate={maxDate}
                    locale={locale}
                    onChange={onChange}
                />
            </DatePickerWrap>
        </FieldWrapper>
    );
};
